export default (data, string = null) => {
	if (string === null) return data;

	const newData = data.map((entity) => {
		if (entity.name.toLowerCase().includes(string.toLowerCase())) return {...entity};

		return {
			...entity,
			items: entity.items.filter(
				({engId, engDes}) =>
					`${engId}`.toLowerCase().includes(string.toLowerCase()) ||
					`${engDes}`.toLowerCase().includes(string.toLowerCase())
			)
		};
	});

	return newData.filter(({items}) => items.length > 0);
};
